
  import React, { useState,useCallback } from "react";
  import {Route, Routes,useNavigate} from 'react-router-dom'
  import IcecatDataPage from "../generatedTablePage/IcecatDataPage";
  import ModalComponent from "../components/Modal";
  import { Outlet } from "react-router-dom";
  import AddProduct from "../generatedAddEdit/product/AddProduct";
  import EditProduct from "../generatedAddEdit/product/EditProduct";
import EditIcecat from "../generatedAddEdit/icecat/EditIcecat";
  

  
  
  const ProductRoutes = () => {


    return (
      <Routes> 
      
    <Route
    path="/"
    element={<IcecatDataPage/>}
  />
  <Route
    path="/edit"
    element={
      <EditIcecat/>
    }
  />
  <Route
    path="/add"
    element={
      <AddProduct/>
    }
  />      
         
      </Routes>
    );
  };
  export default ProductRoutes
